/* @flow */
import React, { Component } from 'react';
import Tile from './shop/tile.js';
import percentageChange from './../../../utils/percentage-change.js';
import formatNumber from '../../../formatters/number.js';
import formatCurrency from '../../../formatters/currency.js';
import './shop.css';

class Shop extends Component {

  constructor(props) {
    super(props);
    const cFrames = this.props.cFrames;
    const pFrames = this.props.pFrames;
    const applyCount = (n: number, obj): number => {
      return n + obj['count'];
    };
    const applyShopAndItemCounts = (n: number, obj): number => {
      return n + obj['item_views'].reduce(applyCount, obj['shop_views']);
    };
    const applyImpressionCounts = (n: number, obj): number => {
      return n + obj['item_impressions'].reduce(applyCount, 0);
    };
    const cViewsFigure = cFrames.reduce(applyShopAndItemCounts, 0);
    const pViewsFigure = pFrames.reduce(applyShopAndItemCounts, 0);
    const viewsPct = percentageChange(cViewsFigure, pViewsFigure, 1);
    const cImpressionsFigure = cFrames.reduce(applyImpressionCounts, 0);
    const pImpressionsFigure = pFrames.reduce(applyImpressionCounts, 0);
    const impressionsPct = percentageChange(cImpressionsFigure, pImpressionsFigure, 1);
    const cFavItemsFigure = cFrames.reduce((n: number, frame): number => {
      return n + frame['item_favourites'];
    }, 0);
    const pFavItemsFigure = pFrames.reduce((n: number, frame): number => {
      return n + frame['item_favourites'];
    }, 0);
    const favItemsPct = percentageChange(cFavItemsFigure, pFavItemsFigure, 1);
    const cFavShopsFigure = cFrames.reduce((n: number, frame): number => {
      return n + frame['shop_favourites'];
    }, 0);
    const pFavShopsFigure = pFrames.reduce((n: number, frame): number => {
      return n + frame['shop_favourites'];
    }, 0);
    const favShopsPct = percentageChange(cFavShopsFigure, pFavShopsFigure, 1);
    const cOrders = this.props.cOrders;
    const pOrders = this.props.pOrders;
    const cSoldItemsFigure = cOrders.reduce((n: number, order): number => {
      return n + order['count'];
    }, 0);
    const pSoldItemsFigure = pOrders.reduce((n: number, order): number => {
      return n + order['count'];
    }, 0);
    const soldItemsPct = percentageChange(cSoldItemsFigure, pSoldItemsFigure, 1); 
    const cRevenueFigure = cOrders.reduce((n: number, order): number => {
      return n + parseFloat(order['total_value']);
    }, 0);
    const pRevenueFigure = pOrders.reduce((n: number, order): number => {
      return n + parseFloat(order['total_value']);
    }, 0);
    const revenuePct = percentageChange(cRevenueFigure, pRevenueFigure, 1);
    this.state = {
      viewsFigure: cViewsFigure,
      viewsPercentageChange: viewsPct,
      impressionsFigure: cImpressionsFigure,
      impressionsPercentageChange: impressionsPct,
      favouriteItemsFigure: cFavItemsFigure,
      favouriteItemsPercentageChange: favItemsPct,
      favouriteShopsFigure: cFavShopsFigure,
      favouriteShopsPercentageChange: favShopsPct,
      soldItemsFigure: cSoldItemsFigure,
      soldItemsPercentageChange: soldItemsPct,
      totalOrderItems: this.props.totalOrderItems,
      revenueFigure: cRevenueFigure,
      revenuePercentageChange: revenuePct,
      totalRevenue: this.props.totalRevenue,
    };
  }

  render() {
    const numberFormatter = (n: number): string => {
      return formatNumber(n);
    };
    const moneyFormatter = (n: number): string => { 
      return formatCurrency(n);
    };
    const viewsFooter = <p>of your shop & items</p>;
    const impressionsFooter = <p>when your items appear in searches & gift guides</p>;
    const favouriteItemsFooter = <p><a href={this.props.endpoints.eventsPage()}>see who's favourited you</a></p>;
    const favouriteShopsFooter = <p><a href={this.props.endpoints.eventsPage()}>see who's favourited you</a></p>;
    const soldItemsFooter = <p>total items ever sold: <strong>{numberFormatter(this.state.totalOrderItems)}</strong></p>;
    const revenueFooter = <p>all time revenue: <strong>{moneyFormatter(this.state.totalRevenue)}</strong></p>;
    return (
      <section className="Shop">
        <header>
          <h2>About your shop</h2>
        </header>
        <ul>
          <li>
            <Tile title="views" 
                  figure={this.state.viewsFigure} 
                  formatter={numberFormatter}
                  percentageChange={this.state.viewsPercentageChange} 
                  footElement={viewsFooter}
                />
          </li>
          <li>
            <Tile title="impressions"
                  figure={this.state.impressionsFigure}
                  formatter={numberFormatter}
                  percentageChange={this.state.impressionsPercentageChange}
                  footElement={impressionsFooter}
                />
          </li>
          <li>
            <Tile title="favourited your items"
                  figure={this.state.favouriteItemsFigure}
                  formatter={numberFormatter}
                  percentageChange={this.state.favouriteItemsPercentageChange}
                  footElement={favouriteItemsFooter}
                />
          </li>
          <li>
            <Tile title="favourited your shop"
                  figure={this.state.favouriteShopsFigure}
                  formatter={numberFormatter}
                  percentageChange={this.state.favouriteShopsPercentageChange}
                  footElement={favouriteShopsFooter}
                />
          </li>
          <li>
            <Tile title="sold items"
                  figure={this.state.soldItemsFigure}
                  formatter={numberFormatter}
                  percentageChange={this.state.soldItemsPercentageChange}
                  footElement={soldItemsFooter}
                />
          </li>
          <li>
            <Tile title="revenue"
                  figure={this.state.revenueFigure}
                  formatter={moneyFormatter}
                  percentageChange={this.state.revenuePercentageChange}
                  footElement={revenueFooter}
                />
          </li>
        </ul>
      </section>
    );
  }

}

export default Shop;



// WEBPACK FOOTER //
// ./src/app/stats/container/shop.js